@if(!showOnlyOptIns){
  @let isHighLighted = isOfferHighlighted();

  <div class="offerCard offer-card {{ isHighLighted ? 'highlight' : '' }}" id="offerCard"
       [ngClass]="showOnOfferPage ? 'h-100 pb-5 offer-card--on-page' : 'offer-card--default'" #offerCard>

    @if (highlightIds?.length > 0) {
      @if (isHighLighted) {
        <div class="highlight offer-card__highlight-text"
             [innerHTML]="translationService.getTranslation('offer_highlight_text')"></div>
      } @else {
        <div class="noHighlight offer-card__no-highlight"></div>
      }
    }

    <mat-card appearance="outlined" class="offer-card__mat-card"
              [ngClass]="showOnOfferPage ? 'h-100 offer-card__mat-card--on-page pointer' : 'offer-card__mat-card--default'" (click)="showOnOfferPage ? openOrder(offer?.orderChoiceKey): null">
      <div class="heading h4 text-center offer-card__heading" tabindex="0" [innerHTML]="offer?.description">
      </div>
      <div class="offerImage offer-card__image">
        @if (offer?.image?.src) {
          <img mat-card-image class="offer-card__image-img"
               [ngSrc]="offer?.image?.src"
               [width]="imageService.width"
               [height]="imageService.height"
               [priority]="true"
               [alt]="offer?.image?.altText">
          }
      </div>
      <mat-card-content class="mt-3 mb-3 h-100 offer-card__content"
                        tabindex="0" [innerHTML]="summarySafeHtml"></mat-card-content>
      @if (showOnOfferPage) {
        <div class="footer offer-card__footer">
          @if (offer?.priceCalculationActivated) {
            <div class="text-center offer-card__price">
              <div class="h5">{{(offer?.combiPriceCalculated ? offer?.combiPriceCalculated : offer?.offerPrice?.price) | currency}}</div>
              <div class="offer-card__price-desc" [innerHTML]="offer?.additionalPriceDescription"></div>
            </div>
          } @else {
            <div class="text-center offerPrice offer-card__price-summary">
              <div class="h5 offer-card__price-summary-value" [innerHTML]="offer?.priceCalculationSummary"></div>
            </div>
          }
          <div class="text-center offerButton offer-card__order-btn">
            <button mat-raised-button color="primary"
                    class="offer-card__order-btn-button"
                    (click)="openOrder(offer?.orderChoiceKey)">
              {{translationService.getTranslation('button_order')}}
            </button>
          </div>
        </div>
      }
      @if (!showOnOfferPage) {
        <div class="container-fluid">
          @if (showOrderSummaryDetails()) {
          <div class="mb-3 offer-card__details">
            @if (bonuses && bonuses.length > 0) {
              <div class="offerBonus offer-card__bonus">
                <hr aria-hidden="true" class="offer-card__bonus-separator">
                @for (bonus of bonuses; track bonus; let i = $index) {
                  <div class="offer-card__bonus-item">
                    <div class="h5 offer-card__bonus-title"
                         [innerHTML]="translationService.getTranslation('step_orderBonus')"> {{ i + 1 }}
                    </div>
                    <div class="offer-card__bonus-name" [innerHTML]="bonus.name"></div>
                  </div>
                }
              </div>
            }

          <div tabindex="0" style="outline: none" class="offer-card__address-block">
            @if (showAddressSummary()) {
              <hr aria-hidden="true" class="offer-card__address-separator">
              <div class="h5 offer-card__address-title"
                   [innerHTML]="translationService.getTranslation('step_orderAddr')"></div>
            }
            @if (showDeliveryAddress()) {
              <div class="row offerDeliveryAddress offer-card__delivery-address">
                <div class="col-6 offer-card__delivery-label"
                     [innerHTML]="translationService.getTranslation('address_delivery')"></div>
                <div class="col-6 offer-card__delivery-value">
                  <ul class="list-unstyled offer-card__delivery-list">
                    <li class="offer-card__delivery-person">
                      {{ isString(deliveryAddress?.person?.salutation) ?  deliveryAddress?.person?.salutation : deliveryAddress?.person?.salutation?.description }} {{ titleText(deliveryAddress?.person?.title) }} {{ deliveryAddress?.person?.initials ? deliveryAddress?.person?.initials : deliveryAddress?.person?.firstname ?? deliveryAddress?.person?.firstName }} {{ deliveryAddress?.person?.middlename }} {{ deliveryAddress?.person?.lastname ??  deliveryAddress?.person?.lastName}}
                    </li>
                    <li class="offer-card__delivery-address-line">
                      {{ deliveryAddress?.address?.street }} {{ deliveryAddress?.address?.houseno ?? deliveryAddress?.address?.houseNo| houseNoPipe }}
                    </li>
                    <li class="offer-card__delivery-city-line">
                      {{ deliveryAddress?.address?.zipcode }}&nbsp;{{ deliveryAddress?.address?.city }}
                    </li>
                  </ul>
                </div>
              </div>
            }
            @if (showBillingAddress()) {
              <div class="row offerBillingAddress offer-card__billing-address">
                <div class="col-6 offer-card__billing-label"
                     [innerHTML]="translationService.getTranslation('address_billing')"></div>
                <div class="col-6 offer-card__billing-value">
                  <ul class="list-unstyled offer-card__billing-list">
                    <li class="offer-card__billing-person">
                      {{ isString(billingAddress?.person?.salutation) ?  billingAddress?.person?.salutation : billingAddress?.person?.salutation?.description  }} {{ titleText(billingAddress?.person?.title) }} {{ billingAddress?.person?.firstname ??  billingAddress?.person?.firstName}} {{ billingAddress.person.lastname ?? billingAddress.person.lastName}}
                    </li>
                    <li class="offer-card__billing-address-line">
                      {{ billingAddress?.address?.street }} {{ billingAddress?.address?.houseno ?? billingAddress?.address?.houseNo| houseNoPipe }}
                    </li>
                    <li class="offer-card__billing-city-line">
                      {{ billingAddress?.address?.zipcode }}&nbsp;{{ billingAddress?.address?.city }}
                    </li>
                  </ul>
                </div>
              </div>
            }
            @if (showBonusAddress()) {
              <div class="row offerBonusAddress offer-card__bonus-address">
                <div class="col-6 offer-card__bonus-label"
                     [innerHTML]="bonusAddressTitle()"></div>
                <div class="col-6 offer-card__bonus-value">
                  <ul class="list-unstyled offer-card__bonus-list">
                    <li class="offer-card__bonus-person">
                      {{ isString(bonusAddress?.person?.salutation) ?  bonusAddress?.person?.salutation : bonusAddress?.person?.salutation?.description }} {{ titleText(bonusAddress?.person?.title) }} {{ bonusAddress?.person?.firstname ?? bonusAddress?.person?.firstName }} {{ bonusAddress?.person?.lastname ?? bonusAddress?.person?.lastName }}
                    </li>
                    <li class="offer-card__bonus-address-line">
                      {{ bonusAddress?.address?.street }} {{ (bonusAddress?.address?.houseno ?? bonusAddress?.address?.houseNo) | houseNoPipe }}
                    </li>
                    <li class="offer-card__bonus-city-line">
                      {{ bonusAddress?.address?.zipcode }}&nbsp;{{ bonusAddress?.address?.city }}
                    </li>
                  </ul>
                </div>
              </div>
            }
            @if (showAdvertiserAddress()) {
              <div class="row offerAdvertiserAddress offer-card__advertiser-address">
                <div class="col-6 offer-card__advertiser-label"
                     [innerHTML]="translationService.getTranslation('address_advertiser')"></div>
                <div class="col-6 offer-card__advertiser-value">
                  <ul class="list-unstyled offer-card__advertiser-list">
                    <li class="offer-card__advertiser-person">
                      {{ isString(advertiserAddress?.person?.salutation) ? advertiserAddress?.person?.salutation : advertiserAddress?.person?.salutation?.description }} {{ titleText(advertiserAddress?.person?.title) }} {{ advertiserAddress?.person?.firstname ?? advertiserAddress?.person?.firstName }} {{ advertiserAddress?.person?.lastname ?? advertiserAddress?.person?.lastName }}
                    </li>
                    <li class="offer-card__advertiser-address-line">
                      {{ advertiserAddress?.address?.street }} {{ (advertiserAddress?.address?.houseno ?? advertiserAddress?.address?.houseNo) | houseNoPipe }}
                    </li>
                    <li class="offer-card__advertiser-city-line">
                      {{ advertiserAddress?.address?.zipcode }}&nbsp;{{ advertiserAddress?.address?.city }}
                    </li>
                  </ul>
                </div>
              </div>
            }
            @if (paymentCode || paymentFrequency) {
              <hr aria-hidden="true" class="offer-card__payment-separator">
              <div class="h5 offer-card__payment-title"
                   [innerHTML]="translationService.getTranslation('step_orderPayment')"></div>
            }
            @if (paymentCode) {
              <div class="row offerPaymentCode offer-card__payment-code">
                <div class="col-6 offer-card__payment-code-label"
                     [innerHTML]="translationService.getTranslation('payment_type')"></div>
                <div class="col-6 offer-card__payment-code-value">{{ paymentCode.description }}</div>
              </div>
            }
            @if (paymentFrequency) {
              <div class="row offerPaymentFrequency offer-card__payment-frequency">
                <div class="col-6 offer-card__payment-frequency-label"
                     [innerHTML]="translationService.getTranslation('payment_rhythm')"></div>
                <div class="col-6 offer-card__payment-frequency-value">{{ paymentFrequency.description }}</div>
              </div>
            }
            @if (startDate) {
              <hr aria-hidden="true" class="offer-card__startdate-separator">
              <div class="h5 offer-card__startdate-title"
                   [innerHTML]="translationService.getTranslation('step_orderDateAndOptins')"></div>
              <div class="row offerStartDate offer-card__startdate">
                <div class="col-6 offer-card__startdate-label"
                     [innerHTML]="translationService.getTranslation('startdate')"></div>
                <div
                  class="col-6 offer-card__startdate-value">{{ startDate | date: translationService.getTranslation('dateFormat') }}
                </div>
              </div>
            }
            <div #saveButtonPoint id="saveButtonPoint" style="visibility: hidden" class="offer-card__save-point"></div>
            @if (showPriceSegment) {
              @if (hasCalculatedPrices()) {
                <hr aria-hidden="true" class="offer-card__prices-separator">
                <div class="h5 offer-card__prices-title"
                     [innerHTML]="translationService.getTranslation('step_check')"></div>
                <div class="row mb-2 offer-card__prices-row">
                  <div class="col-6 offer-card__prices-label"
                       [innerHTML]="translationService.getTranslation('price')"></div>
                  @for (price of prices; track price) {
                    @if (offer?.priceCalculationActivated) {
                      <div
                        class="col-6 offer-card__prices-value">{{ price?.price | number : '1.2-2' }} {{ price.currency }}
                        @if (price.porto) {
                          <div
                            class="offer-card__prices-delivery"
                            [innerHTML]="translationService.getTranslation('price_delivery') + ' ' + (price?.porto | number : '1.2-2') + ' ' + price.currency">
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="col-6 offer-card__prices-text">{{ price?.priceText }}</div>
                    }
                    <div class="col-6 offer-card__prices-empty"></div>
                  }
                </div>
              } @else if (hasConfiguredPriceInfo()) {
                <!-- Vorläufiger Preis aus der Angebots-Konfiguration, solange noch keine Preisberechnung erfolgt ist -->
                <hr aria-hidden="true" class="offer-card__prices-separator">
                <div class="h5 offer-card__prices-title"
                     [innerHTML]="translationService.getTranslation('step_check')"></div>
                <div class="row mb-2 offer-card__prices-row">
                  <div class="col-6 offer-card__prices-label"
                       [innerHTML]="translationService.getTranslation('price')"></div>
                  @if (offer?.priceCalculationActivated) {
                    <div class="col-6 offer-card__prices-value">
                      {{ (offer?.combiPriceCalculated ? offer?.combiPriceCalculated : offer?.offerPrice?.price) | currency }}
                      @if (offer?.additionalPriceDescription) {
                        <div class="offer-card__prices-desc" [innerHTML]="offer?.additionalPriceDescription"></div>
                      }
                    </div>
                  } @else {
                    <div class="col-6 offer-card__prices-text" [innerHTML]="offer?.priceCalculationSummary"></div>
                  }
                </div>
              }
            }
          </div>
          </div>
          }
        </div>
      }
      </mat-card>
  </div>
} @else {
  @if (this.additionalAgbInfo1 != null) {
    <div class="offer-card__agb-info1" [innerHTML]="additionalAgbInfo1"></div>
  }

  @if (disclaimerMode === DisclaimerMode.SEPARATE_CHECKBOXES) {
    <div class="col-12 offer-card__agb-checkbox">
      <mat-checkbox [(ngModel)]="agb" required aria-required="true"
                    class="text-wrap offer-card__agb-checkbox-input" #agbBox
                    (change)="onAgreementChanged('agb')"
                    data-cy="checkbox-agb">
        <div class="offer-card__agb-checkbox-label"
             [innerHTML]="translationService.getTranslation('order_agbaccept_epaper')"></div>
      </mat-checkbox>
      @if (shouldShowAgreementError('agb')) {
        <mat-error class="small errorOffset offer-card__agb-checkbox-error"
                   [innerHTML]="translationService.getTranslation('order_agbaccept_epaper_error')"></mat-error>
      }
    </div>
    <div class="col-12 offer-card__disclaimer-checkbox">
      <mat-checkbox [(ngModel)]="disclaimer" required aria-required="true"
                    class="text-wrap offer-card__disclaimer-checkbox-input" #disclaimerBox
                    (change)="onAgreementChanged('disclaimer')"
                    data-cy="checkbox-disclaimer">
        <div class="offer-card__disclaimer-checkbox-label"
             [innerHTML]="translationService.getTranslation('order_widerrufInfo')"></div>
      </mat-checkbox>
      @if (shouldShowAgreementError('disclaimer')) {
        <mat-error class="small errorOffset offer-card__disclaimer-checkbox-error"
                   [innerHTML]="translationService.getTranslation('order_widerrufInfo_error')"></mat-error>
      }
    </div>
    <div class="col-12 offer-card__privacy-checkbox">
      <mat-checkbox [(ngModel)]="privacy" required aria-required="true"
                    class="text-wrap offer-card__privacy-checkbox-input" #privacyBox
                    (change)="onAgreementChanged('privacy')"
                    data-cy="checkbox-privacy">
        <div class="offer-card__privacy-checkbox-label"
             [innerHTML]="translationService.getTranslation('order_privacyInfo')"></div>
      </mat-checkbox>
      @if (shouldShowAgreementError('privacy')) {
        <mat-error class="small errorOffset offer-card__privacy-checkbox-error"
                   [innerHTML]="translationService.getTranslation('order_privacyInfo_error')"></mat-error>
      }
    </div>
  } @else if (disclaimerMode === DisclaimerMode.ONE_CHECKBOX) {
    <div class="col-12 offer-card__privacy-disclaimer-agb-checkbox">
      <mat-checkbox [(ngModel)]="privacyDisclaimerAgb"
                    class="text-wrap offer-card__privacy-disclaimer-agb-checkbox-input" required
                    aria-required="true" #privacyDisclaimerAgbBox
                    data-cy="checkbox-agb-disclaimer-privacy"
                    (change)="onAgreementChanged('privacyDisclaimerAgb')">
        <div class="offer-card__privacy-disclaimer-agb-checkbox-label"
             [innerHTML]="translationService.getTranslation('order_privacyDisclaimerAgb')"></div>
      </mat-checkbox>
      @if (shouldShowPrivacyDisclaimerAgbError()) {
        <mat-error class="alignEnd offer-card__privacy-disclaimer-agb-checkbox-error"
                   [innerHTML]="translationService.getTranslation('order_privacyDisclaimerAgb_error')"></mat-error>
      }
    </div>
  }

  <!-- Widerrufsverzicht als eigene Checkbox in allen DREI Opt-In-Modi rendern, da für digitale
       Angebote (E-Paper/PaidContent) Pflicht (siehe checkBoxesChecked()), sofern nicht per Config
       'digitalOrder.revocationWaiver' abgeschaltet. Außerhalb des kombiniert/getrennt-@if/@else,
       damit die Checkbox auch im kombinierten Modus sichtbar ist und der Bestell-Button aktivierbar bleibt. -->
  @if (askForRevocationWaiver()) {
    <div class="col-12 offer-card__epaper-revocation-waiver-checkbox">
      <mat-checkbox [(ngModel)]="epaperRevocationWaiver" required aria-required="true"
                    class="text-wrap offer-card__epaper-revocation-waiver-checkbox-input"
                    (change)="onAgreementChanged('epaperRevocationWaiver')"
                    data-cy="checkbox-epaper-revocation-waiver">
        <div class="offer-card__epaper-revocation-waiver-checkbox-label"
             [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver')"></div>
      </mat-checkbox>
      @if (shouldShowAgreementError('epaperRevocationWaiver')) {
        <mat-error class="small errorOffset offer-card__epaper-revocation-waiver-checkbox-error"
                   [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver_error')"></mat-error>
      }
    </div>
  }
  @if (this.additionalAgbInfo2 != null) {
    <div class="offer-card__agb-info2" [innerHTML]="additionalAgbInfo2"></div>
  }

  @if (offer?.optIns?.length > 0) {
    <ng-container>
      @for (optin of offer.optIns; track optin) {
        <div class="col-12 offer-card__optin">
          <mat-checkbox class="text-wrap offer-card__optin-checkbox"
                        [required]="optin.mandatory" aria-required="true"
                        (change)="onOptInClick($event, optin)">
            <div class="offer-card__optin-label" [innerHTML]="optin.description"></div>
          </mat-checkbox>
          @if (optin.mandatory && shouldShowOptinError(optin.id)) {
            <mat-error class="small errorOffset offer-card__optin-error"
                       [innerHTML]="translationService.getTranslation('order_optin_error')">
            </mat-error>
          }
        </div>
      }
    </ng-container>
  }

  @if (showOrderButton()) {
    <!-- Ohne Checkbox steht der Erklärungstext direkt über dem Bestell-Button und gilt mit der
         Buchung als angenommen (P5W-4396). -->
    @if (disclaimerMode === DisclaimerMode.TEXT_WITHOUT_CHECKBOX) {
      <div class="col-12 mt-3 offer-card__privacy-disclaimer-agb-hint"
           data-cy="hint-agb-disclaimer-privacy"
           [innerHTML]="translationService.getTranslation('order_privacyDisclaimerAgb')"></div>
    }
    <div class="row offerCard-orderSend offer-card__order-send">
      <div class="col offer-card__order-actions">
        @if (stepper) {
          <button mat-raised-button
                  type="button"
                  class="offer-card__order-back-btn me-3"
                  (click)="stepper.previous()"
                  [innerHTML]="translationService.getTranslation('button_back')">
          </button>
        }
        <button mat-raised-button color="primary" type="button" [disabled]="isOrderButtonDisabled()"
                (click)="saveOrder()" data-cy="btn-create-order" class="offer-card__order-send-btn-button"
                [innerHTML]="((!!prices && prices[0]?.price > 0) || !offer?.priceCalculationActivated)
                  ? translationService.getTranslation('button_orderSend')
                  : translationService.getTranslation('button_orderSendFree')"></button>
      </div>
    </div>
  }
}
